<template>
    <div class="box-container">
        <div id="flag"></div>
        <div class="container-size-fixer">
            <div id="title">
                برنامه های مهاجرتی
            </div>
            <div v-if="programs" class="row" style="padding-bottom: 50px;margin: 0">
                <div v-for="program in programs" @click.prevent="$router.push('/category-view/'+program.slug)"
                     class="col-lg-4 col-md-6 col-sm-12  immigration-program-information-box" :key="program">
                    <div class="immigration-program-information-box-content">
                        <div v-if="program.icon_image">
                            <img width="80" :src="$store.state.base_urls.webUploads + program.icon_image" alt="">
                        </div>
                        <div>{{program.name}}</div>
                        <div>
                            {{program.short_explain}}
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="loadingMood" class="row" style="padding-bottom: 50px;height: 350px">
                <div style="height: 350px;padding: 50px;;margin: auto">
                    <img style="height: auto;width: 100%" src="../assets/loader/ezgif.com-gif-maker(1).gif" alt="loader">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "HomeSectionTwo",
        data(){
            return {
                programs: null,
                loadingMood:false,
            }
        },
        methods:{
            async getPageInfos() {
                try {
                    this.loadingMood = true;
                    let response = await axios.get('api/getMainCategories/GeneralImmigrationPrograms',);
                    this.loadingMood = false;
                    this.programs = response.data.results;

                } catch (error) {
                    console.log(error)
                }
            },
        },
        mounted() {
            this.getPageInfos();
        },
    }
</script>

<style scoped>
    .box-container {
        position: relative;
        overflow: hidden;
    }

    .container-size-fixer {
        margin: 10px auto 0 auto;
        padding-top: 50px;
    }

    #flag {
        background-image: url("../assets/appIcons/Pics/Flag.png");
        background-size: cover;
        background-repeat: no-repeat;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        opacity: 0.1;
        height: 100%;
        width: 100%;
        position: absolute;
    }

    .immigration-program-information-box-content > div {
        height: auto;
        width: 100%;
    }

    .immigration-program-information-box-content > div:nth-child(1) > img {
        margin-top: 20px;
    }

    .immigration-program-information-box-content > div:nth-child(2) {
        font-family: 'IRANSans';
        font-size: 22px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        margin-top: 20px;
        color: #1a1a1a;
    }

    .immigration-program-information-box-content > div:nth-child(3) {
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #1a1a1a;
        margin-top: 10px;
        padding-right: 33px;
        padding-left: 33px;
    }


    .immigration-program-information-box {
        height: 300px;
        /*002060*/
        padding: 15px;
        cursor: pointer;
    }

    .immigration-program-information-box-content {
        width: 100%;
        height: 100%;
        border-radius: 10px;
        -webkit-backdrop-filter: blur(1px);
        backdrop-filter: blur(1px);
        box-shadow: 0 0 10px 0 rgba(255, 0, 0, 0.1);
        background-color: white !important;
        border: 2px solid transparent;
        background-color: rgba(255, 255, 255, 0.7);
        /*background-color: rgba(255, 255, 255, 0.7);*/
    }

    .immigration-program-information-box-content:hover {
        border: 2px solid #fe7063;
    }

    #space {
        width: 100%;
        height: 10px !important;
        background-color: #162336;
    }

    .section-one-main-child:nth-child(2) {
        width: 100%;
        height: auto;
        padding: 50px 135px;
        /*opacity: 0.05;*/
        background-size: cover;
        background-repeat: no-repeat;
    }

    #home-section-two {
        width: 100%;
        height: auto;
        margin: auto;
    }

    #title {
        width: 100%;
        height: 57px;
        margin-top: 0px;
        margin-bottom: 50px;
        font-family: 'IRANSans';
        font-size: 26px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
        padding-right: 15px;
    }


    @media (max-width: 1300px) {
        #title {
            font-size: 30px;
        }

        .section-one-main-child {
            padding: 15px !important;
        }

        .section-one-main-child:nth-child(2) {
            height: auto !important;
        }
    }
</style>